import type { FitsBand, FitsFileMeta, FitsGroup, FitsGroupFiles } from "./types"

// Example Slooh filenames:
// ngc1977_20251120_052023_0_ctjqim_l_cal.fit
// ngc1977_20251120_052128_0_ff4xh8_r_cal.fit
// We want to group by the target prefix (e.g., "ngc1977") rather than the
// full run-specific stem, so use the first token before an underscore.
const SLOOH_REGEX = /^([^_]+).*_([lrgb])_cal\.fits?$/i

export function groupSloohFits(files: FitsFileMeta[]): FitsGroup[] {
  const groups = new Map<string, FitsGroupFiles>()

  for (const file of files) {
    const match = file.name.match(SLOOH_REGEX)
    if (!match) continue

    const baseKey = match[1]
    const bandLetter = match[2].toLowerCase() as FitsBand

    let entry = groups.get(baseKey)
    if (!entry) {
      entry = {}
      groups.set(baseKey, entry)
    }

    entry[bandLetter] = file
  }

  const result: FitsGroup[] = []

  for (const [baseKey, groupFiles] of groups.entries()) {
    if (groupFiles.r && groupFiles.g && groupFiles.b) {
      result.push({
        id: baseKey,
        baseKey,
        files: groupFiles,
      })
    }
  }

  result.sort((a, b) => a.baseKey.localeCompare(b.baseKey))

  return result
}


